import type React from "react";

import { type IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

interface Props {
  text?: string;
  icon?: IconDefinition;
}

export const EmptyResultOverlay: React.FC<Props> = ({ text, icon }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Stack alignItems="center" spacing={2} m={6}>
      {icon ? (
        <FontAwesomeIcon icon={icon} size="3x" color={theme.colors.redesign.db40} />
      ) : (
        <FontAwesomeIcon icon={faMagnifyingGlass} size="3x" color={theme.colors.redesign.db40} />
      )}
      <Typography variant="subtitle1" color={theme.colors.redesign.db40}>
        {text || t("usercourse.no_result")}
      </Typography>
    </Stack>
  );
};
